import { render, staticRenderFns } from "./addOnes.vue?vue&type=template&id=da89f8b2&scoped=true"
import script from "./addOnes.vue?vue&type=script&lang=js"
export * from "./addOnes.vue?vue&type=script&lang=js"
import style0 from "./addOnes.vue?vue&type=style&index=0&id=da89f8b2&prod&lang=scss&scoped=true"
import style1 from "./addOnes.vue?vue&type=style&index=1&id=da89f8b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da89f8b2",
  null
  
)

export default component.exports